/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 24/12/2021
 */
import OAuthToken from "@shared/integrations/OAuthToken";
import {Type} from "class-transformer";
import SubCalendarItem from "@shared/integrations/calendar/SubCalendarItem";
import {CalendarTypeEnum} from "@shared/integrations/calendar/CalendarTypeEnum";
import BaseObject from "@shared/BaseObject";
import {uuidv4} from "@/utils/helpers";

export default class CalendarItem extends BaseObject {

	id: string = null

	@Type(() => SubCalendarItem)
	subCalendarItems: SubCalendarItem[] = []

	calendarType: CalendarTypeEnum = null

	calendarEmail: string = null


	@Type(() => OAuthToken)
	oauthToken: OAuthToken = null;
	isTokenRevoked: boolean = false


	constructor(calendarType: CalendarTypeEnum = null) {
		super()
		if(!this.id){
			this.id = uuidv4()
		}
		this.calendarType = calendarType;
	}

	isGCalendar(){
		return this.calendarType === CalendarTypeEnum.GOOGLE
	}
	isOutlookCalendar(){
		return this.calendarType === CalendarTypeEnum.OUTLOOK
	}
	isICAlCalendar(){
		return this.calendarType === CalendarTypeEnum.ICAL
	}

	// createPrimarySubCalendar(){
	// 	let subCalendarItem = new SubCalendarItem("primary", this.calendarEmail, true, true)
	// 	this.subCalendarItems.push(subCalendarItem)
	// }

	findSubCalendarItemIndex(subCalendarItem){
		return this.subCalendarItems.findIndex(item => item.calendarId === subCalendarItem.calendarId)
	}

	addSubCalendarItemUnique(subCalendarItem){
		let res = false
		if(this.findSubCalendarItemIndex(subCalendarItem) < 0){
			this.subCalendarItems.push(subCalendarItem)
			res = true
		}
		console.log("addSubCalendarItemUnique: isAdded = ", res, ", subCalendarItem = ", subCalendarItem)
		return res
	}

	removeSubCalendarItem(subCalendarItem){
		let index = this.findSubCalendarItemIndex(subCalendarItem)
		if(index >= 0){
			this.subCalendarItems.splice(index, 1)
		}
	}

	setWriteToPrimarySubCalendar(){
		this.resetWriteToSubCalendars()
		let subCalendarItem = this.getPrimarySubCalendar()
		if(subCalendarItem){
			subCalendarItem.setCanWriteSessions(true)
		}
	}

	setWriteToSubCalendar(calendarId = "primary"){
		this.resetWriteToSubCalendars()
		let subCalendarItem = this.getSubCalendarById(calendarId)
		subCalendarItem.setCanWriteSessions(true)
	}

	resetWriteToSubCalendars(){
		for(let subCalendarItem of this.subCalendarItems){
			subCalendarItem.setCanWriteSessions(false)
		}
	}

	hasWriteToSubCalendar(){
		return !!this.getWriteToSubCalendar()
	}

	hasReadFromSubCalendar(){
		return this.getReadFromSubCalendars().length > 0
	}

	getWriteToSubCalendar(){
		for(let subCalendarItem of this.subCalendarItems){
			if(subCalendarItem.canWriteSessions){
				return subCalendarItem
			}
		}
	}

	getReadFromSubCalendars(){
		let res = []
		for(let subCalendarItem of this.subCalendarItems){
			if(subCalendarItem.canCheckForConflicts){
				res.push(subCalendarItem)
			}
		}
		return res
	}

	getPrimarySubCalendar(){
		let index = this.subCalendarItems.findIndex(item => item.isPrimary)
		if(index >= 0){
			return this.subCalendarItems[index]
		}
	}

	getSubCalendarById(calendarId){
		let index = this.subCalendarItems.findIndex(item => item.calendarId === calendarId)
		if(index >= 0){
			return this.subCalendarItems[index]
		}
	}
}
